export const Orientations = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  OVERLAY: 'overlay',
  START: 'start',
  CENTER: 'center',
  END: 'end'
};

export const Colors = {
  DARK_GRAY: 'dark-gray'
};
